import React, { useState } from 'react';
import { api } from '../api';
import PasswordField from '../components/PasswordField';

export default function Login({ onLogin, onSwitchToSignup }) {
  const [name, setName]         = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy]         = useState(false);
  const [error, setError]       = useState('');

  async function submit(e) {
    e.preventDefault();
    if (busy) return;
    setError('');
    if (!name.trim() || !password) {
      setError('Enter your name and password');
      return;
    }
    setBusy(true);
    try {
      const { user, token } = await api.login({ name: name.trim(), password });
      onLogin({ user, token });
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="screen-login">
      <div className="ll">
        <div className="ll-logo">
          <div className="ll-logo-sq"><img src="/vehicle-flow-logo-256.png" alt="VF" /></div>
          <div>
            <div className="ll-logo-name">Vehicle Flow</div>
            <div className="ll-logo-sub">Melville Motors Group</div>
          </div>
        </div>
        <div className="ll-title">Welcome back</div>
        <div className="ll-sub">Sign in to access the workflow system</div>

        <form onSubmit={submit}>
          <label className="lfl">Your Name</label>
          <input
            className="lfi"
            type="text"
            placeholder="First name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
            autoComplete="username"
          />

          <label className="lfl">Password</label>
          <PasswordField
            placeholder="••••••••"
            value={password}
            onChange={setPassword}
            autoComplete="current-password"
          />

          {error && (
            <div style={{
              background: 'rgba(187,22,43,.15)',
              border: '1px solid rgba(187,22,43,.4)',
              color: '#ff8a98',
              padding: '8px 12px',
              borderRadius: 8,
              fontSize: 12,
              marginBottom: 14,
            }}>{error}</div>
          )}

          <button type="submit" className="btn-in" disabled={busy}>
            {busy ? 'Signing in…' : 'Sign In →'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: 18, fontSize: 12, color: 'var(--sidebar-muted)' }}>
          Don't have an account?{' '}
          <button
            type="button"
            onClick={onSwitchToSignup}
            style={{
              background: 'transparent', border: 'none', color: 'var(--accent)',
              cursor: 'pointer', fontWeight: 600, fontFamily: 'inherit', fontSize: 12,
              textDecoration: 'underline', padding: 0,
            }}
          >Sign up</button>
        </div>

        <div className="ll-foot">Powered by <span>Acts Car Detailing</span></div>
      </div>

      <div className="lr">
        <img src="/login-banner.jpg" alt="Vehicle Flow — Every car. Every team. One screen." className="lr-banner" />
      </div>
    </div>
  );
}
